import { z } from 'zod';

export const requestSchema = z.object({
  email: z.string().email(),
});

export type RequestInput = z.infer<typeof requestSchema>;
